// extracted by mini-css-extract-plugin
export default {"faqTabContainer":"styles_faqTabContainer__AAl7N","faqTabItem":"styles_faqTabItem__FHOw0","activeFAQ":"styles_activeFAQ__6-UMY"};